import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Button, Typography, Stack, Box } from "@mui/material";
import DataTable from "../../components/DataTable";
import AddCategoryFrom from "./AddCategoryFrom";
import {
  fetchCategories,
  selectNumberOfPages,
  setCategoriesTableSettings,
  cleanTableSettings
} from "../../redux/module/category";
import useAppDispatch from "../../hooks/useAppDispatch";
import useAppSelector from "../../hooks/useAppSelector";
import categoryTableColumns from "./categoryTableColumns";
import { formatAgGridFilters, formatAgGridSorting } from "../../distflowAPI/common";
import PageLoading from "../../components/PageLoading";

const defaultColDef = {
  flex: 1,
  filter: true,
  floatingFilter: true,
};

const Categories = () => {
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const {categories, pageSize, page, orderBy, filterBy, categoriesLoading} = useAppSelector((state) => state.category);

  const numberOfPages = useAppSelector(selectNumberOfPages);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    dispatch(fetchCategories({ page, pageSize, filterBy, orderBy }));   
  }, [pageSize, page, filterBy, orderBy]);

  useEffect(() => {
    const params = new URLSearchParams();
    filterBy.forEach((item) => {
      params.set(item.column, item.value);
    });
    setSearchParams(params);
  }, [filterBy]);
  
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleChange = (field, value) => {
    if (field === "filterBy" || field === "pageSize") {
      dispatch(setCategoriesTableSettings({ field: "page", value: 1 }));
    }
    dispatch(setCategoriesTableSettings({ field, value }));
  };

  useEffect(() => {
    return () => {
      dispatch(cleanTableSettings())
    }
  }, []);

  return (
    <>
      <PageLoading dataLoading={categoriesLoading} />
      
      <Typography fontSize="23px" fontWeight={800} component="h2" data-testid="page-title">
        Categories
      </Typography>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "space-between", sm: "center" }}
        justifyContent="space-between"
        spacing={1.5}
        my="25px"
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing="15px"
        >
          <Button onClick={handleOpen} variant="contained">
            Add New
          </Button>
        </Stack>
      </Stack>

      <Box className="table-wrapper">
        <DataTable
          rowData={categories}
          columnDefs={categoryTableColumns}
          defaultColDef={defaultColDef}
          suppressSorting={true} //disable default sorting
          loading={categoriesLoading}
          rowHeight={53}
          headerHeight={60}
          onSortChanged={(event) =>
            handleChange("orderBy", formatAgGridSorting(event.columnApi.columnModel.gridColumns))
          }
          onFilterChanged={(event) =>
            handleChange("filterBy", formatAgGridFilters(event.api.getFilterModel()) || [])
          }
          page={page}
          pageSize={pageSize}
          setPageSize={(pageSize) => handleChange("pageSize", pageSize)}
          noPages={numberOfPages}
          setPage={(page) => handleChange("page", page)}
        />
      </Box>
      <AddCategoryFrom open={open} handleClose={handleClose} />
    </>
  );
};

export default Categories;
